import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'

export class SettingsService {
  private setError: (message: string | null) => void

  constructor (setError: (message: string | null) => void) {
    this.setError = setError
  }

  async getSettings () {
    return axiosInstance
      .get('/settings')
      .then(res => res.data.data)
      .catch(e => ResponseHelper.handleError(e, this.setError))
  }

  async getPrice (price: string) {
    return axiosInstance
      .get('/settings/price', {
        params: {
          price
        }
      })
      .then(res => res.data.data)
      .catch(e => ResponseHelper.handleError(e, this.setError))
  }
}
